import teamMembers from './team-members';
import clients from './clients';

let messages = Object.assign({}, teamMembers, clients);

export default messages;
